import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ESliceKeys } from '../../internal/ESliceKeys';

export type MapBounds = [YMaps.TCoord, YMaps.TCoord];
export type MapCenter = YMaps.TCoord;

export type MapConfigurationState = {
  center: MapCenter;
  zoom: number;
  bounds: MapBounds;
};

const mapConfigurationInitialState: MapConfigurationState = {
  bounds: [
    [0, 0],
    [0, 0],
  ],
  center: [0, 0],
  zoom: 12,
};

export const { reducer: mapConfigurationReducer, actions: mapConfigurationActions } = createSlice({
  initialState: mapConfigurationInitialState,
  name: ESliceKeys.MapConfiguration,
  reducers: {
    setMapConfiguration(state, action: PayloadAction<MapConfigurationState>) {
      state.bounds = action.payload.bounds;
      state.center = action.payload.center;
      state.zoom = action.payload.zoom;
    },
  },
});
